module.exports = __webpack_public_path__ + "static/media/top-img_4@2x.c5d70688.png";